module.exports = __webpack_public_path__ + "img/124.693046b.jpg";